import React, { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";
export default function LocationAutocomplete({ value = "", onChange, onLocationSelect, placeholder = "Search location", }) {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const listenerRef = useRef(null);
  const retryTimerRef = useRef(null);
  const [inputValue, setInputValue] = useState(value || "");
  useEffect(() => {
    setInputValue(value || "");
  }, [value]);
  useEffect(() => {
    let mounted = true;
    const initializeAutocomplete = () => {
      if (!mounted) {
        return;
      }
      if (!inputRef.current) {
        return;
      }

      if (
        !window.google ||
        !window.google.maps ||
        !window.google.maps.places
      ) {
        retryTimerRef.current = setTimeout(initializeAutocomplete, 500);
        return;
      }
      if (autocompleteRef.current) {
        return;
      }
      autocompleteRef.current =
        new window.google.maps.places.Autocomplete(
          inputRef.current,
          {
            types: ["geocode"],
            componentRestrictions: { country: "in", },
            fields: ["formatted_address", "geometry", "name", "place_id",],
          }
        );
      listenerRef.current =
        autocompleteRef.current.addListener("place_changed", () => {
          const place = autocompleteRef.current?.getPlace();
          if (
            !place ||
            !place.geometry ||
            !place.geometry.location
          ) {
            return;
          }
          const address = place.formatted_address || place.name || "";
          const locationData = {
            address,
            name: place.name || "",
            placeId: place.place_id || "",
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
          setInputValue(address);
          if (onChange) {
            onChange(address);
          }
          if (onLocationSelect) {
            onLocationSelect(locationData);
          }
        }
        );
    };
    initializeAutocomplete();
    return () => {
      mounted = false;
      if (retryTimerRef.current) {
        clearTimeout(retryTimerRef.current);
        retryTimerRef.current = null;
      }
      if (
        listenerRef.current &&
        window.google?.maps
      ) {
        window.google.maps.event.removeListener(
          listenerRef.current
        );
      }
      listenerRef.current = null;
      autocompleteRef.current = null;
    };
  }, []);
  const handleChange = (e) => {
    const text = e.target.value;
    setInputValue(text);
    if (onChange) {
      onChange(text);
    }
    if (onLocationSelect) {
      onLocationSelect(null);
    }
  };
  return (
    <div className="input-icon location-input">
      <MapPin size={18} />
      <input
        ref={inputRef}
        type="text"
        value={inputValue}
        placeholder={placeholder}
        autoComplete="off"
        onChange={handleChange} />
    </div>
  );
}